import { createSelector } from '@ngrx/store';
import { CoreState, getCoreState } from '../../../store/reducers';
import { LocaleState } from '../reducers/locale.reducer';

const getLocaleState = createSelector(
  getCoreState,
  (state: CoreState) => state.locale,
);

const getSelected = (state: LocaleState) => state.selected;

export const getLocaleSelected = createSelector(getLocaleState, getSelected);
